import React, { useRef, useState, useEffect } from "react";
import "./PodcastPlayer.css";

const PodcastPlayer = ({ title, src, duration }) => {
  const audioRef = useRef(null);
  const progressBarRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const audio = audioRef.current;
    const updateTime = () => setCurrentTime(audio.currentTime);
    audio.addEventListener("timeupdate", updateTime);
    audio.addEventListener("ended", () => setIsPlaying(false));
    return () => {
      audio.removeEventListener("timeupdate", updateTime);
    };
  }, []);

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleSeek = (e) => {
    const progressBar = progressBarRef.current;
    const rect = progressBar.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;
    const newTime = (clickX / width) * duration;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div className={`podcast-player ${isPlaying ? "active" : ""}`}>
      <audio ref={audioRef} src={src} />
      <button onClick={togglePlayPause}>{isPlaying ? "⏸" : "▶"}</button>
      <div className="podcast-details">
        <strong>{title}</strong>
        <div className="time-row">
          <span>{formatTime(currentTime)}</span>
          <div
            className="progress-bar"
            ref={progressBarRef}
            onClick={handleSeek}
          >
            <div
              className="progress"
              style={{ width: `${(currentTime / duration) * 100}%` }}
            />
          </div>
          <span>{formatTime(duration)}</span>
        </div>
      </div>
      <div className="volume-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="19"
          viewBox="0 0 24 19"
          fill="none"
        >
          <path
            d="M1 10.9998V7.28584C1 6.7554 1.21071 6.24669 1.58579 5.87162C1.96086 5.49655 2.46957 5.28584 3 5.28584H5.9C6.09552 5.28579 6.28674 5.22842 6.45 5.12084L12.45 1.16484C12.6008 1.06556 12.7756 1.00893 12.9559 1.00097C13.1362 0.993013 13.3154 1.03401 13.4743 1.11962C13.6332 1.20523 13.766 1.33226 13.8585 1.48723C13.9511 1.64219 14 1.81933 14 1.99984V16.2858C14 16.4663 13.9511 16.6435 13.8585 16.7984C13.766 16.9534 13.6332 17.0804 13.4743 17.166C13.3154 17.2517 13.1362 17.2927 12.9559 17.2847C12.7756 17.2767 12.6008 17.2201 12.45 17.1208L6.45 13.1648C6.28674 13.0572 6.09552 12.9999 5.9 12.9998H3C2.46957 12.9998 1.96086 12.7891 1.58579 12.414C1.21071 12.039 1 11.5303 1 10.9998Z"
            stroke="black"
            stroke-width="1.5"
          />
          <path
            d="M17.5 4.64282C17.5 4.64282 19 6.14282 19 8.64282C19 11.1428 17.5 12.6428 17.5 12.6428M20.5 1.64282C20.5 1.64282 23 4.14282 23 8.64282C23 13.1428 20.5 15.6428 20.5 15.6428"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default PodcastPlayer;
